import FlyoutOpenContent from './FlyoutOpenContent';

export default FlyoutOpenContent;
